// Temporary placeholder hooks for AI Studio components
// TODO: Implement these hooks properly for the configurator

import { useState, useCallback } from 'react';
import useStore from '../../Store';

// Hook to check if the viewport is mobile
export const useIsMobile = (): boolean => {
	const isMobile = useStore((state) => state.isMobile);
	return isMobile;
};

// Hook to get the currently selected side
// TODO: Implement with actual configurator logic
export const useSelectedSide = () => {
	const [selectedSide] = useState<number | null>(null);
	return selectedSide;
};

// Hook to get the currently selected variant
// TODO: Implement with actual configurator logic
export const useSelectedVariant = () => {
	const [selectedVariant] = useState<any>(null);
	return selectedVariant;
};

// Hook for speech-to-text functionality
// TODO: Implement with Web Speech API or third-party service
export const useSpeechToText = () => {
	const [isListening, setIsListening] = useState(false);
	const [transcript] = useState('');

	// Check if Web Speech API is available
	const speechApiAvailable = typeof window !== 'undefined' && ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window);

	const startListening = useCallback((initialPrompt?: string) => {
		console.warn('useSpeechToText: startListening not implemented');
		setIsListening(true);
		// TODO: Implement Web Speech API integration
		// If initialPrompt is provided, append transcription to it
	}, []);

	const stopListening = useCallback(() => {
		console.warn('useSpeechToText: stopListening not implemented');
		setIsListening(false);
	}, []);

	return {
		speechApiAvailable,
		isListening,
		transcript,
		startListening,
		stopListening,
	};
};

// Hook to check microphone permissions
// TODO: Implement with Navigator.mediaDevices.getUserMedia
export const useMicrophonePermission = () => {
	const [permissionState] = useState<'granted' | 'denied' | 'prompt'>('prompt');
	const [featurePolicyMicrophone] = useState<boolean | undefined>(undefined);

	// Check if microphone is available via feature policy
	// Feature Policy API is still experimental, so we default to undefined
	// TODO: Implement proper feature policy check when stable

	const requestPermission = useCallback(async () => {
		console.warn('useMicrophonePermission: requestPermission not implemented');
		// TODO: Implement Navigator.mediaDevices.getUserMedia
		return false;
	}, []);

	return {
		permissionState,
		featurePolicyMicrophone,
		requestPermission,
	};
};

// Hook to fire user file upload dialog
// TODO: Implement file upload functionality
export const useFireUserFileUpload = () => {
	const fireUserFileUpload = useCallback((callback: (file: File) => void, accept?: string) => {
		const input = document.createElement('input');
		input.type = 'file';
		input.accept = accept || 'image/*';
		input.onchange = (e: any) => {
			const file = e.target.files?.[0];
			if (file) {
				callback(file);
			}
		};
		input.click();
	}, []);

	return fireUserFileUpload;
};

// Export the app store
export { default as useAppStore } from '../../Store';
